import React from "react";
import Productpage from "../../productpage2";
import SEO from "../../seo";

const featureimg =
  "https://eclipsemattress.in/assets/images/products/accolade-pt/Accolade%20PT-12.png";

const gal1 =
  "https://eclipsemattress.in/assets/images/products/accolade-pt/Accolade%20PT-04.png";
const gal2 =
  "https://eclipsemattress.in/assets/images/products/accolade-pt/Accolade%20PT-01.png";
const gal3 =
  "https://eclipsemattress.in/assets/images/products/accolade-pt/Accolade%20PT-02.png";
const gal4 =
  "https://eclipsemattress.in/assets/images/products/accolade-pt/Accolade%20PT-03.png";

const warranty =
  "https://eclipsemattress.in/assets/images/products/accolade-pt/Accolade%20PT-05.png";

const icon1 =
  "https://eclipsemattress.in/assets/images/products/accolade-pt/Accolade%20PT-11.png";
const icon2 =
  "https://eclipsemattress.in/assets/images/products/accolade-pt/Accolade%20PT-06.png";
const icon3 =
  "https://eclipsemattress.in/assets/images/products/accolade-pt/Accolade%20PT-07.png";
const icon4 =
  "https://eclipsemattress.in/assets/images/products/accolade-pt/Accolade%20PT-08.png";
const icon5 =
  "https://eclipsemattress.in/assets/images/products/accolade-pt/Accolade%20PT-09.png";
const icon6 =
  "https://eclipsemattress.in/assets/images/products/accolade-pt/Accolade%20PT-10.png";

export default function AccoladePTPage({ location }) {
  const data = {
    galleryImages: [gal1, gal2, gal3, gal4],
    productName: "Accolade PT",
    productLogo:
      "https://eclipsemattress.in/wp-content/uploads/2021/06/Eclipse_sub-brand_logo-03.png",
    descriptionTitle: "A Champion In The Bedroom: Pocketed 5 Zone Mattress",
    descriptionText:
      "When you are looking for sound rest and relaxation, our Accolade mattress should be your first choice. Accolade mattress is endorsed by the Chiropractic state association of the USA for its unparalleled quality and inventive mechanisms. That means that no matter what position you sleep in, this mattress makes sure that you sleep like a winner.",
    category: { title: "Patent Series", link: "/patent-series-mattress/" },
    warrantyIcons: [
      "https://eclipsemattress.in/assets/features/logo-02.png",
      "https://eclipsemattress.in/assets/features/logo-05.png",
      "https://eclipsemattress.in/assets/features/logo-03.png",
      "https://eclipsemattress.in/assets/features/logo-06.png",
      icon2,
      icon3,
      icon4,
      icon5,
      icon6,
      icon1,
    ],
    featuresText: [
      "Patented zones made with combination of Memory Foam & Beligum Latex",
      "Memory Foam",
      "Eclipse Natural Belgium Latex",
      "HD Eclipse Pure Foam",
      "Turkish Cotton Felt",
      "HD Pocket Spring System",
      "Patented Life Edge Perimeter Support",
    ],
    featuresImage: featureimg,
    warrantyImage: warranty,
    price: "₹40,599 - ₹1,36,299",

    points: [
      "Patented Inbalance Technology: 5 different zones for individual support & comfort levels",
      "Supports the body’s natural S-curve",
      "Endorsed by the US Congress of State Chiropractic Association (COSCA)",
      "Spinal Zone patented technology for enhanced back support",
      "Foam encased side border with patented Life Edge Perimeter Support technology",
    ],

    relatedProducts: [
      {
        title: "Coil On Coil",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/coiloncoil.jpg",
        link: "/patent-series-mattress/coil-on-coil/",
      },
      {
        title: "Harmony Ortho",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/harmonyortho.jpg",
        link: "/harmony-collection/harmony-ortho/",
      },
      {
        title: "Posture Comfort",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/posturecomfort.jpg",
        link: "/luxury-collection/posture-comfort/",
      },
    ],
  };

  return (
    <div>
      <SEO
        title="Accolade Pocket Spring Mattress | Eclipse International"
        description={`Buy Accolade Pocket spring mattress in 8" & 10" sizes with 10 years warranty that gives you sound rest and relaxation to your body and sleep like a winner. Recommended by chiropractors`}
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-accoladept.jpg"
      />
      <Productpage location={location} product={data} />
    </div>
  );
}
